import React from 'react';
import PropTypes from 'prop-types';
import translator from '../../translations/drupalTranslator';
import PriceI18NHOC from '../../hoc/PriceI18NHOC';

export const MinimumPriceFormatterComponent = ({price}) => {
  const minimumPriceText = translator.translate('Minimum price');

  return (
    <span className="service__name-description">
      {`${minimumPriceText} ${price.amount} ${price.currencyCode}`}
    </span>
  );
};

MinimumPriceFormatterComponent.PropTypes = {
  price:PropTypes.shape({
    amount:PropTypes.string.isRequired,
    currencyCode:PropTypes.string.isRequired,
  }).isRequired,
};

export default PriceI18NHOC(MinimumPriceFormatterComponent);
